export default "__VITE_ASSET__1157ff79__"